import ApiHelper from '@/utils/api-helper'
import API from '@/constants/api'

class LearnSuggestionService {
  static getLearnSuggestions(limit = 100, page = 1) {
    return ApiHelper.fetch(`${API.URL + API.LEARN_SUGGESTION}?pageSize=${limit}&page=${page}`)
  }

  static getLearnSuggestion(id) {
    return ApiHelper.fetch(`${API.URL + API.LEARN_SUGGESTION}/${id}`)
  }

  static addLearnSuggestion(learnSuggestion) {
    return ApiHelper.fetch(`${API.URL + API.LEARN_SUGGESTION}`, {
      method: 'POST',
      body: JSON.stringify({
        learnSuggestion
      })
    })
  }

  static updateLearnSuggestion(learnSuggestion) {
    if (typeof learnSuggestion._id === 'undefined') {
      return this.addLearnSuggestion(learnSuggestion)
    }

    return ApiHelper.fetch(`${API.URL + API.LEARN_SUGGESTION}/${learnSuggestion['_id']}`, {
      method: 'PUT',
      body: JSON.stringify({
        learnSuggestion
      })
    })
  }

  static deleteLearnSuggestion(id) {
    return ApiHelper.fetch(`${API.URL + API.LEARN_SUGGESTION}/${id}`, {
      method: 'DELETE'
    })
  }
}

export default LearnSuggestionService
